export default __webpack_public_path__ + "v3.406/youtube-icon.png";